import React from 'react';
import { GlobalStyles } from '../../styles/styledComponents/globalStyles';
import ParticlesContainer from '../Particles/ParticlesContainer';
import PriceBannerBlock from '../PriceBannerBlock/PriceBannerBlock';
import IntroductionSectionContainer from '../IntroductionSection/IntroductionSectionContainer';
import LegalLines from '../LegalLines/LegalLines';
import FAQ from '../FAQ/FAQ';
import UbisoftPlusNavigation from '../UbisoftPlusNavigation/UbisoftPlusNavigation';
import StarterPack from '../StarterPack/StarterPack';
import InformationCardsContainer from '../InformationCards/InformationCardsContainer';
import PartnerGamesContainer from '../PartnerGames/PartnerGamesContainer';
import {
    Container,
    LargeContainer,
    PageBackground,
    PageBackgroundContainer
} from './PageContainerStyle';
import CONFIG from '../../config';

const PageContainer = () => {
    return (
        <>
            {/*Global styles defenition*/}
            <GlobalStyles />

            {/*Animated background*/}
            <PageBackgroundContainer>
                <PageBackground>
                    <ParticlesContainer />
                </PageBackground>
            </PageBackgroundContainer>

            {/*Page blocks*/}
            {/*Removed navigation bar for upc*/}
            {!CONFIG.isUPC &&  <UbisoftPlusNavigation/>}
            <IntroductionSectionContainer />
            <Container>
                <InformationCardsContainer />
            </Container>
            <PartnerGamesContainer />
            <Container>
                <StarterPack />
            </Container>
            <PriceBannerBlock />
            <LargeContainer>
                <FAQ />
                <LegalLines />
            </LargeContainer>
        </>
    );
};

export default PageContainer;
